// ■コンポーネント説明
// ニュース年アーカイブナビ表示用コンポーネント

import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';

import * as styles from '@/styles/page/news.module.scss';

export interface NewsNaviProps {
  CurrentYear?: string;
}

const NewsNavi: React.FC<NewsNaviProps> = (props) => {
  const { CurrentYear } = props;

  const data = useStaticQuery<GatsbyTypes.NewsNaviQuery>(
    graphql`
      query NewsNavi {
        allMicrocmsNews(
          sort: { fields: publishedAt, order: DESC }
          filter: { newsId: { ne: "template" } }
        ) {
          edges {
            node {
              year: publishedAt(formatString: "YYYY")
            }
          }
        }
      }
    `,
  );
  const tempYearArray = [];
  data.allMicrocmsNews.edges.map(({ node }) => {
    tempYearArray.push(node.year);
    return null;
  });
  const YearArray = Array.from(new Set(tempYearArray));

  return (
    <div className="list-rect">
      {React.Children.toArray(
        YearArray.map((value, index) => (
          <>
            {CurrentYear === YearArray[index] && (
              <div
                key={YearArray[index]}
                className={`${styles.news_contents__year} ${styles.__current}`}
              >
                <p className="list-rect__item">
                  <strong>{YearArray[index]}</strong>
                </p>
              </div>
            )}
            {CurrentYear !== YearArray[index] && (
              <Link
                key={YearArray[index]}
                to={`/news/${YearArray[index]}/`}
                className={styles.news_contents__year}
              >
                <p className="list-rect__item">
                  <strong>{YearArray[index]}</strong>
                </p>
              </Link>
            )}
          </>
        )),
      )}
    </div>
  );
};

export default NewsNavi;
